export default "__VITE_ASSET__B0QO00vw__"